import { render, staticRenderFns } from "./UploadOldImage.vue?vue&type=template&id=d3ec915c&"
import script from "./UploadOldImage.vue?vue&type=script&lang=js&"
export * from "./UploadOldImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadOldImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports